//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { IDownloadPdfRequest } from '@apis/screen-capture/screenCaptureApiModels';
import { isDefined } from '@utils/filterPredicates';
import { saveBlob } from '@utils/saveBlob';
import { serializedGatewayFetch } from '@utils/sessionFetch';

const OUTPUT_TYPE_PDF = 'PDF';
const SCREEN_CAPTURE_PDF_HEADERS = {
  'content-type': 'application/pdf',
};

function screenCaptureFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<Response> {
  return serializedGatewayFetch(
    'screen_capture',
    `/api/v1/screen-capture/${endpoint}`,
    init,
  );
}

function getFilename(pageName: string): string {
  const dt = new Date();
  return `
    ${pageName}Report_
    ${dt.getUTCFullYear()}${dt.getUTCMonth() + 1}${dt.getUTCDate()}_
    ${dt.getMilliseconds()}.pdf
    `.replace(/\s*/g, '');
}

function saveArrayBuffer(arrayBuffer: ArrayBuffer, filename: string) {
  saveBlob(arrayBuffer, filename, SCREEN_CAPTURE_PDF_HEADERS);
}

export async function downloadPdfReport(
  { dateRange, pageName, filename, ...requestParams }: IDownloadPdfRequest,
  init?: RequestInit,
) {
  const params = {
    ...requestParams,
    triggerName: 'CaptureScreenRequest',
    outputType: OUTPUT_TYPE_PDF,
    startDate: dateRange?.startDate,
    endDate: dateRange?.endDate,
    pageName,
    filename,
  };

  const res = await screenCaptureFetch('dashboard-screen-capture', {
    method: 'POST',
    body: JSON.stringify(params),
    ...(isDefined(init?.signal) && { signal: init?.signal }),
  });

  const arrayBuffer = await res.arrayBuffer();
  if (arrayBuffer.byteLength === 0) {
    throw Error('Error generating PDF');
  }

  const reportFilename = filename ?? getFilename(pageName);
  saveArrayBuffer(arrayBuffer, reportFilename);
}
